import React, { FC } from 'react';
import { StylableComponentProps } from '@clds/common-definitions';
import { MarkdownContainer, StyledReactMarkdown } from './MarkdownContainer';
import { RecipeContentProvider, RecipeContentContextType } from './RecipeContentContext';
import { CodeRenderer } from './renderers/CodeRenderer';
import { AssetRenderer } from './renderers/AssetRenderer';

const renderers = {
  code: CodeRenderer,
  image: AssetRenderer,
};

export type RecipeContentProps = StylableComponentProps &
  Pick<RecipeContentContextType, 'copyCallback' | 'languageChangeCallback'> & {
    children: string;
  };

export const RecipeContent: FC<React.PropsWithChildren<RecipeContentProps>> = ({ children, className, copyCallback, languageChangeCallback }) => (
  <MarkdownContainer className={className}>
    <RecipeContentProvider value={{ languageChangeCallback, copyCallback }}>
      <StyledReactMarkdown renderers={renderers} linkTarget="_blank" escapeHtml={false}>
        {children}
      </StyledReactMarkdown>
    </RecipeContentProvider>
  </MarkdownContainer>
);
